import React from 'react';
import { MdCheckCircle } from 'react-icons/md';

interface DeliverySuccessPopupProps {
  isOpen: boolean;
  onContinue: () => void;
}

export const DeliverySuccessPopup: React.FC<DeliverySuccessPopupProps> = ({
  isOpen,
  onContinue,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-8 text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-4">
          <MdCheckCircle className="w-20 h-20 text-green-500" />
        </div>

        {/* Success Message */}
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          Order Placed Successfully!
        </h3>
        <p className="text-gray-600 mb-6">
          Your delivery order has been confirmed. We'll get it to you soon!
        </p>

        {/* Action Button */}
        <button
          onClick={onContinue}
          className="w-full bg-red-500 text-white py-3 rounded-lg font-semibold hover:bg-red-600 transition-colors"
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
};
